module.exports = __webpack_public_path__ + "static/media/responsive@2x.3447694e.jpg";